import { WorkflowsState } from "@idw-types/state/workflows-state";
import { FormattedWorkflowConfiguration } from "@idw-types/data/workflow-configuration";
import { WorkflowsActionTypes, WorkflowsActions } from "../actions/workflows-actions";

export const initialWorkflowsState: WorkflowsState = {
    workflowConfigurations: {
        workflowConfigurations: null,
        isLoading: false
    }
}

export const workflowsReducer = (
    state: WorkflowsState = initialWorkflowsState,
    action: WorkflowsActions
): WorkflowsState => {
    switch (action.type) {
        // Workflows
        case WorkflowsActionTypes.SET_WORKFLOW_CONFIGURATIONS_LOADING:
            return {
                ...state,
                workflowConfigurations: {
                    ...(action.payload.isLoading
                        ? { ...initialWorkflowsState.workflowConfigurations }
                        : { ...state.workflowConfigurations }),
                    isLoading: action.payload.isLoading
                }
            };
        case WorkflowsActionTypes.SET_WORKFLOW_CONFIGURATIONS:
            return {
                ...state,
                workflowConfigurations: {
                    workflowConfigurations: action.payload.workflowConfigurations,
                    isLoading: false
                }
            };
        case WorkflowsActionTypes.REPLACE_WORKFLOW_CONFIGURATION:
            return {
                ...state,
                workflowConfigurations: {
                    ...state.workflowConfigurations,
                    workflowConfigurations: replaceWorkflowConfiguration(
                        state.workflowConfigurations.workflowConfigurations,
                        action.payload.workflowConfiguration
                    )
                }
            };
        case WorkflowsActionTypes.REMOVE_WORKFLOW_CONFIGURATION:
            return {
                ...state,
                workflowConfigurations: {
                    ...state.workflowConfigurations,
                    workflowConfigurations: removeWorkflowConfiguration(
                        state.workflowConfigurations.workflowConfigurations,
                        action.payload.workflowConfiguration
                    )
                }
            };
        default:
            return state;
    }
};

const replaceWorkflowConfiguration = (
    workflowConfigurations: Array<FormattedWorkflowConfiguration>,
    newWorkflowConfiguration: FormattedWorkflowConfiguration
) => {
    return workflowConfigurations.map(config => config.id === newWorkflowConfiguration.id ? newWorkflowConfiguration : config);
};

const removeWorkflowConfiguration = (
    workflowConfigurations: Array<FormattedWorkflowConfiguration>,
    workflowConfigurationToRemove: FormattedWorkflowConfiguration
) => {
    return workflowConfigurations.filter(wc => wc.id !== workflowConfigurationToRemove.id);
};